export default "__VITE_ASSET__mW_wQ25N__"